import { Accordion, AccordionSummary, AccordionDetails, keyframes, styled } from '@mui/material';
import { Colors } from 'library';

export const IconCircle = styled('div')<{ size?: number }>(({ size = 40 }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: Colors.turquoise,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
}));

export const CardWrapper = styled('div')({
    marginTop: 20,
    border: `1.5px solid ${Colors.lightGrey}`,
    borderRadius: 12,
    overflow: 'hidden',
});

export const StyledAccordion = styled(Accordion)({
    '&.MuiAccordion-root': {
        backgroundColor: 'transparent',
        '&:before': { display: 'none' },
    },
});

export const StyledAccordionSummary = styled(AccordionSummary)({
    padding: '12px 20px',
    backgroundColor: '#FDF8F0',
    borderBottom: `1px solid ${Colors.lightGrey}`,
    '& .MuiAccordionSummary-content': {
        margin: 0,
    },
});

export const StyledAccordionDetails = styled(AccordionDetails)({
    padding: 20,
    backgroundColor: '#FBF6EE',
});

export const SummaryContent = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 16,
});

export const Logo = styled('img')<{ width?: number }>(({ width = 56 }) => ({
    width,
    height: width,
    objectFit: 'contain',
}));

export const TitleBlock = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
});

export const InfoCardGrid = styled('div')({
    display: 'grid',
    gap: 16,
    paddingBottom: 16,
});

const infoCardStyles = {
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 12,
    padding: 20,
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 4,
};

export const InfoCard = styled('div')(infoCardStyles);

export const InfoCardLink = styled('a')({
    ...infoCardStyles,
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: Colors.faintGrey,
    },
});

export const ExternalLink = styled('a')({
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    padding: 20,
    backgroundColor: Colors.white,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 12,
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: Colors.faintGrey,
    },
});

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const scaleIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

export const FadeSlideIn = styled('div')<{ delay?: number }>(({ delay = 0 }) => ({
    opacity: 0,
    animation: `${fadeSlideUp} 0.4s ease-out ${delay}ms forwards`,
}));

export const AnimatedLogo = styled('img')<{ width?: number }>(({ width = 60 }) => ({
    width,
    marginBottom: 12,
    opacity: 0,
    animation: `${scaleIn} 0.5s ease-out 100ms forwards`,
}));

export const HeaderSection = styled('div')({
    background: `linear-gradient(135deg, ${Colors.darkNavy} 0%, ${Colors.darkNavy} 100%)`,
    padding: '36px 30px 28px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: `1px solid ${Colors.lightGrey}`,
});

export const ModalBody = styled('div')({
    padding: '24px 30px 30px',
});

export const PartnershipCard = styled('div')({
    backgroundColor: '#FBF6EE',
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    border: `1px solid ${Colors.lightGrey}`,
});

export const BenefitsList = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    marginBottom: 10,
});

export const BenefitItem = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});
